import { all, put, call, takeLatest } from 'redux-saga/effects'
import toast from 'react-hot-toast'
import api from '../../../services/axios'

import { CercTypes, OptInSubmitData, OptOutSubmitData } from './types'
import { UserFailureCercOptIn, UserSuccessCercOptIn } from '../auth/actions'

interface ProtocolCerq {
    payload: OptInSubmitData
    type: string
}

interface ProtocolCercOptOut {
    payload: OptOutSubmitData
    type: string
}

function* cerqSubmitOptIn({ payload }: ProtocolCerq): any {
    try {
        const { data } = yield call(api.post, '/optin', {
            cnpj_cpf: payload.cnpj_cpf,
        })
        //limpar mensagem
        yield put(UserSuccessCercOptIn(data.verification_cerc))
        if (data.verification_cerc) {
            // toast.success('Sucesso!')
        } else {
            //exibir mensagem
            // toast.error(data.erroMensagem)
        }
    } catch (error) {
        yield put(UserFailureCercOptIn())
        // toast.error('Algo deu errado!')
    }
}

function* cercSubmitOptOut({ payload }: ProtocolCercOptOut): any {
    try {
        const { data } = yield call(api.post, '/optout', {
            // optInSubmitId: payload.optInSubmitId,
            cnpj_cpf: payload.cnpj_cpf,
        })

        yield put(UserSuccessCercOptIn(data.verification_cerc))
        if (!data.verification_cerc) {
            toast.success('Até logo!')
        } else {
            toast.error(data.erroMensagem)
            // toast.error('cerc opt out')
        }
    } catch (error) {
        yield put(UserFailureCercOptIn())
        toast.error('Algo deu errado!')
    }
}

export default all([
    takeLatest(CercTypes.SUBMIT_OPT_IN, cerqSubmitOptIn),
    takeLatest(CercTypes.SUBMIT_OPT_OUT, cercSubmitOptOut),
])
